
export class LoopCategoryFilter {
    constructor(selected) {
        this.params = selected;
    }

    getQueryString() {
        let params = {};
        _.map(this.params, (cat, field) => {
            params[field] = cat;
        });
        return params;
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/Services/Search/LoopCategoryFilter.js